function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon';
import SubMenu from './SubMenu';
var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    iconName = _ref.iconName,
    text = _ref.text,
    _onClick = _ref.onClick,
    onSubMenuOpen = _ref.onSubMenuOpen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    panelLeftPos = _useState4[0],
    setPanelLeftPos = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    panelTopPos = _useState6[0],
    setPanelTopPos = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    panelWidth = _useState8[0],
    setPanelWidth = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    focusableItems = _useState10[0],
    setItems = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    focusIndex = _useState12[0],
    setFocus = _useState12[1];
  var parentRef = useRef(null);
  var subPanelRef = useRef(null);
  var ntClass = cx({
    menu__item: true,
    'display-flex': true,
    'justify-content-between': true,
    'align-items-center': true,
    'dropdown__item--disabled': disabled
  }, className);
  var panelClass = cx({
    'hover-highlight--primary': !disabled,
    'paddingleft-md': true,
    'paddingright-md': true,
    'display-flex': true,
    'justify-content-between': true,
    'align-items-center': true,
    'width-100p': true,
    'height-small': true
  });
  var _onMouseLeave = function onMouseLeave() {
    setIsOpen(false);
    if (children) onSubMenuOpen(false);
  };
  var _onMouseEnter = function onMouseEnter() {
    var parent = parentRef.current.getBoundingClientRect();
    var curPanelWidth = parent.width + 2;
    var leftPos;
    if (parent.left + parent.width + curPanelWidth < window.innerWidth) {
      leftPos = parent.left + parent.width;
    } else {
      leftPos = parent.left - curPanelWidth;
    }
    /* subtract 9 to parent.top, padding top is 8px with border 1px */
    setPanelLeftPos(leftPos);
    setPanelTopPos(parent.top - 9);
    /* add 2 to the parent.width, border width of right and left is 1px each*/
    setPanelWidth(curPanelWidth);
    setIsOpen(true);
    if (children) onSubMenuOpen(true);
  };
  useEffect(function () {
    var items = [];
    if (subPanelRef.current) {
      items = subPanelRef.current.querySelectorAll('[role="menuitem"]');
    }
    setItems(Array.from(items));
  }, [subPanelRef, isOpen]);
  var _onKeyDown = function onKeyDown(e) {
    if (e.key === 'ArrowRight' && focusableItems.length) {
      e.preventDefault();
      _onMouseEnter();
      setFocus(0);
    } else if (e.key === 'ArrowLeft' && isOpen) {
      e.preventDefault();
      _onMouseLeave();
      parentRef.current.focus();
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    ref: parentRef,
    "aria-disabled": disabled,
    className: ntClass,
    role: "menuitem",
    onClick: function onClick(e) {
      return !disabled && _onClick(e);
    },
    onKeyPress: function onKeyPress(e) {
      return !disabled && _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    tabIndex: -1,
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return _onMouseLeave();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: panelClass
  }, text, iconName ? /*#__PURE__*/React.createElement(Icon, {
    name: iconName
  }) : null, children ? /*#__PURE__*/React.createElement(Icon, {
    name: "chevron_right"
  }) : null), children && /*#__PURE__*/React.createElement(SubMenu, {
    ref: subPanelRef,
    width: panelWidth,
    left: panelLeftPos,
    top: panelTopPos,
    isOpen: isOpen,
    focusIndex: focusIndex
  }, children));
};
MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /** Display the icon aligned right */
  iconName: PropTypes.string,
  // iconType: PropTypes.string,
  /** Text of the menu item */
  text: PropTypes.string,
  /** Callback function when clicking the menuitem */
  onClick: PropTypes.func,
  onSubMenuOpen: PropTypes.func
};
MenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuItem",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "iconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display the icon aligned right"
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text of the menu item"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function when clicking the menuitem"
    },
    "onSubMenuOpen": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default MenuItem;